<template>
  <div class="message_detail">
    <div class="inner">
      <div class="title" v-if="detail.article">{{ detail.article.title }}</div>
      <div class="time" v-if="detail.article">
        {{ $formatTime(detail.modify_at, "yearMonthDay") }}
      </div>
      <div
        class="content"
        v-if="detail.article"
        v-html="detail.article.content"
      ></div>
      <!-- <div class="delete" v-if="detail.article">
        <el-button type="primary" @click="del">{{ $t("刪除") }}</el-button>
      </div> -->
      <vue-editor
        useCustomImageHandler
        @image-added="handleImageAdded"
        v-model="content"
      ></vue-editor>
      <div class="error-message" v-if="showError">{{ $t("请输入关键字") }}</div>
      <div class="hit">
        {{
          $t(
            "發佈辱罵,相同文章重覆發文,誹謗,謠言等違反營運政策的貼文時，可能會受到限制發文，若有違法情事發生，自行負擔法律相關責任. 最長100個字元"
          )
        }}
      </div>
      <el-button type="primary" @click="submit">{{ $t("確認") }}</el-button>
      <div class="comments" v-if="commentsList.length > 0">
        <div class="comments-title">{{ $t("留言") }}</div>
        <div
          class="comments-container"
          v-for="(item, index) in commentsList"
          :key="index"
        >
          <div class="pubtime">
            <span>{{ item.author_nickname }}</span>
            <span>{{ $formatTime(item.modify_at, "normal") }}</span>
          </div>
          <div v-if="item" v-html="item.content"></div>
          <!-- <el-button
            type="primary"
            class="reply"
            @click="reply"
            v-if="!showEditor"
            size="mini"
            >{{ $t("回復") }}</el-button
          > -->
          <div class="children" v-if="item">
            <div class="item" v-for="(it, ind) in item.children" :key="ind">
              <div class="pubtime">
                <span>{{ it.author_nickname }}</span>
                <span>{{ $formatTime(it.modify_at, "normal") }}</span>
              </div>
              <div v-html="it.content"></div>
              <div class="del">
                <el-button size="mini" type="primary">{{
                  $t("刪除")
                }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        :total="total"
        @repeater="repeater"
        v-if="commentsList.length > 0"
      />
    </div>
  </div>
</template>
<script>
// import { mapState } from "vuex";
import { getQuestionDetail, commentsQuestion } from "@/api/serve";
import { getCommentsList } from "@/api/communities";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
  },
  name: "MessageDetail",
  data() {
    return {
      detail: {},
      content: "",
      showError: false,
      commentsList: [],
      total: 0,
    };
  },
  mounted() {
    this.$store.dispatch("getUser");
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    repeater(page) {
      this.page = page;
      this.getCommentsList();
    },
    async getDetail() {
      const res = await getQuestionDetail({ id: this.$route.query.id });
      this.detail = res.data;
      this.getCommentsList();
    },
    async getCommentsList() {
      const res = await getCommentsList({
        limit: 10,
        page: this.page,
        article_id: this.detail.article.id,
      });
      this.commentsList = res.data.results || [];
      this.total = res.data.paging.total;
    },
    async submit() {
      if (this.content) {
        const res = await commentsQuestion({
          article: this.detail.article.id,
          content: this.content,
        });
        if (res.status === 201) {
          this.content = "";
          this.$message.success(this.$t("發送成功"));
          this.getCommentsList();
        }
      } else {
        this.showError = true;
      }
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      let _this = this;
      var formData = new FormData();
      formData.append("file", file);
      fetch(this.$baseUrl + "/1/communities/upload/", {
        method: "POST",
        body: formData,
      })
        .then((data) => {
          return data.json();
        })
        .then((ret) => {
          if (ret.url) {
            let url = ret.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "image", url);
            resetUploader();
          } else if (ret.detail)
            _this.$message({
              message: ret.detail,
              type: "success",
              offset: "100",
            });
          else
            _this.$message({
              message: _this.$t("上載失敗"),
              type: "error",
              offset: "100",
            });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.message_detail {
  background-image: url("~@/assets/img/home/bg_currency.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  .inner {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 40px 0;
    min-height: 80vh;
    text-align: left;
    .title {
      font-size: 28px;
      color: #676a6d;
      text-align: center;
      margin-bottom: 24px;
    }
    .time {
      color: #a8adb3;
      font-size: 16px;
      text-align: center;
      margin-bottom: 40px;
    }
    .head {
      color: #c6a86c;
      font-size: 20px;
      text-align: left;
    }
    .content {
      font-size: 14px;
      color: #676a6d;
      line-height: 2;
      text-align: left;
      white-space: pre-wrap;
      text-indent: 2em;
      margin-bottom: 40px;
    }
    .error-message {
      color: #c26161;
      margin: 8px 4px 0 4px;
      height: 24px;
    }
    .hit {
      margin: 20px 0;
      font-style: 14px;
      letter-spacing: 2px;
    }
    .delete {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;
    }
    .comments {
      margin: 100px auto;
      &-title {
        text-align: left;
        font-size: 32px;
        padding-bottom: 15px;
      }
      &-container {
        margin: 30px 0;
        padding: 30px 0;
        border-top: 1px solid #d6e0eb;
        // border-bottom: 1px solid #d6e0eb;
        color: rgb(104, 106, 110);
        .pubtime {
          color: #a8aeb3;
          font-size: 16px;
          margin-bottom: 20px;
          span {
            padding-right: 20px;
          }
        }
        .reply {
          margin: 30px 0;
        }
        .replyContainer {
          margin: 30px 0;
        }
        .children {
          margin-right: 60px;
          padding: 0 40px;
          //   border: 1px solid #d6e0eb;
          .item {
            font-size: 16px;
            margin: 30px 0;
            color: rgb(104, 106, 110);
            .del {
              display: flex;
              align-items: center;
              justify-content: flex-end;
            }
          }
        }
      }
    }
  }
}
</style>
